/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Box } from '@mui/material';
import React from 'react';
import { ConceptChipConnect } from './ConceptChipConnect';
import type { DataExplorerTypes } from '../../store';

interface ConceptListProps {
  concepts: DataExplorerTypes.Concept[];
  datasetConcepts: string[];
}

export const ConceptList: React.FC<ConceptListProps> = ({
  concepts,
  datasetConcepts,
}) => {
  return (
    <Box
      data-testid="conceptList"
      sx={{
        width: '100%',
        overflowX: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          maxWidth: '100%',
          flexWrap: 'wrap',
          float: 'left',
          fontSize: '0.875rem',
          rowGap: '4px',
          marginRight: '18px',
        }}
      >
        {concepts.map((concept) => {
          return (
            <ConceptChipConnect
              concept={concept}
              isInSearch={datasetConcepts.includes(concept.id)}
              key={concept.id}
            />
          );
        })}
      </Box>
    </Box>
  );
};
